module.exports = __webpack_public_path__ + "static/trig_004-85f8d06487426fd4181552791ca6d2b5.webp";